var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42667 1.55556L10.85 3.11111H14V12.4444H1.55556V3.11111H4.70556L6.12889 1.55556H9.42667V1.55556ZM10.1111 0H5.44444L4.02111 1.55556H1.55556C0.7 1.55556 0 2.25556 0 3.11111V12.4444C0 13.3 0.7 14 1.55556 14H14C14.8556 14 15.5556 13.3 15.5556 12.4444V3.11111C15.5556 2.25556 14.8556 1.55556 14 1.55556H11.5344L10.1111 0ZM7.77778 5.44444C9.06111 5.44444 10.1111 6.49444 10.1111 7.77778C10.1111 9.06111 9.06111 10.1111 7.77778 10.1111C6.49444 10.1111 5.44444 9.06111 5.44444 7.77778C5.44444 6.49444 6.49444 5.44444 7.77778 5.44444ZM7.77778 3.88889C5.63111 3.88889 3.88889 5.63111 3.88889 7.77778C3.88889 9.92444 5.63111 11.6667 7.77778 11.6667C9.92444 11.6667 11.6667 9.92444 11.6667 7.77778C11.6667 5.63111 9.92444 3.88889 7.77778 3.88889Z",
    fill: "#EEEBF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.68c5fcf84dea7dcb731f1de62d303a78.svg";
export { ForwardRef as ReactComponent };